
<div class="black-inputs services-day">
  <el-row>
    <el-row class="dateChooser" :gutter="5">
      <el-input v-if="!isEditing" class="eventName" v-model="name"
        placeholder="Nom de l'évènement (visible par vous uniquement)"></el-input><br><br>
      <el-input class="eventName" v-model="title" placeholder="Titre de l'évènement"></el-input><br><br>
      <el-col v-if="getLink !== ''" :span="18" class="screen-fake-input">{{ getLink }}</el-col>
      <el-input v-model="desc" :autosize="{ minRows: 3 }" type="textarea"
        placeholder="Description de l'évènement"></el-input>
    </el-row>
    <el-row class="dateChooser" :gutter="5">
      <el-col :span="24">
        <el-date-picker class="datePicker" ref="picker" v-model="dates" type="daterange" @change="cleanDays()"
          range-separator="au" start-placeholder="Date de début" end-placeholder="Date de fin" format="dd/MM/yyyy" />
      </el-col>
    </el-row>
  </el-row>
  <el-row>
    <el-checkbox-group v-model="daySelected">
      <el-checkbox-button v-for="day in labelDays" :label="day" :key="day">{{ day }}</el-checkbox-button>
    </el-checkbox-group>
  </el-row>
  <el-row v-if="event">
    <el-col :span="24">
      <div class="services-line">
        <div class="services-line-centered">
          <div class="services-line-container">
            <!-- left -->
            <div class="services-line-service" style='left:0'>
              <div class="services-line-point">
                <span v-if="event && event.capacityIntervalTab &&
                  event.capacityIntervalTab.length > 0 && haveCapacityMin()">
                  <el-popover placement="top" trigger="click" class="black-inputs">
                    <div class="black-inputs">
                      <el-input-number @change="checkIntervalNull(0)" :min="-1"
                        v-model="event.capacityIntervalTab[0].capacity"></el-input-number>
                    </div>
                    <div slot="reference" class="clickBox">{{ event.capacityIntervalTab[0].capacity }}</div>
                  </el-popover>
                </span>
              </div>
              <div class="services-line-hour">{{ event.opening }}</div>
            </div>
            <!-- range -->
            <div class="services-line-service" v-for="hInter in getNumberOfIntervalEventsDyna(event)" :key="hInter.id"
              :style="{ left: ((hInter.id) / (getNumberOfIntervalEventsDyna(event).length + 1)) * 100 + '%' }">
              <div v-if="event && event.capacityIntervalTab &&
                event.capacityIntervalTab[hInter.id] &&
                event.capacityIntervalTab.length > 0">
                <div class="services-line-point">
                  <el-popover placement="top" trigger="click" class="black-inputs">
                    <div class="black-inputs">
                      <el-input-number @change="checkIntervalNull(hInter.id)" :min="-1"
                        v-model="event.capacityIntervalTab[hInter.id].capacity"></el-input-number>
                    </div>
                    <div slot="reference" class="clickBox">{{ event.capacityIntervalTab[hInter.id].capacity }}</div>
                  </el-popover>
                </div>
                <div class="services-line-minihour">{{ hInter.hour }}</div>
              </div>
              <div v-else>
                <div class="services-line-minipoint"></div>
                <div class="services-line-minihour">{{ hInter.hour }}</div>
              </div>
            </div>
            <!-- right -->
            <div class="services-line-service" style='left:98%'>
              <div class="services-line-point">
                <span v-if="event && event.capacityIntervalTab &&
                  event.capacityIntervalTab.length > 0 && haveCapacityMax()">
                  <el-popover placement="top" trigger="click" class="black-inputs">
                    <div class="black-inputs">
                      <el-input-number @change="checkIntervalNull(event.capacityIntervalTab.length - 1)" :min="-1"
                        v-model="event.capacityIntervalTab[event.capacityIntervalTab.length - 1].capacity"></el-input-number>
                    </div>
                    <div slot="reference" class="clickBox">
                      {{ event.capacityIntervalTab[event.capacityIntervalTab.length - 1].capacity }}</div>
                  </el-popover>
                </span>
              </div>
              <div class="services-line-hour">{{ event.closing }}</div>
            </div>
            <div class="services-line-bckg"></div>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
  <el-form v-if="event" class="services-day-parameters" ref="event" :model="event">
    <el-row :gutter="40">
      <el-col :span="12">
        <el-form-item label="Ouverture">
          <el-time-select :value="event.opening" @input="changeThenCallInputInit($event, 'opening')" :picker-options="{
            start: '05:30',
            step: '00:15',
            end: '23:30'
          }" :clearable="false" placeholder="Select time">
          </el-time-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="Fermeture">
          <el-time-select :value="event.closing" @input="changeThenCallPopulateCT($event, 'closing')" :picker-options="{
            start: '05:30',
            step: '00:15',
            end: '23:30'
          }" :clearable="false" placeholder="Select time">
          </el-time-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="Capacité">
          <el-input-number :value="event.capacity" @input="changeSimple($event, 'capacity')" :min="1">
          </el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="Capacité par tranche horaire">
          <el-input-number :value="event.capacityIntervalMain" :key="event.capacityIntervalMain"
            @input="changeThenCallPopulateCT($event, 'capacityIntervalMain')" :min="0">
          </el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="Durée d'un service">
          <el-time-select :value="event.lenghtService" @input="changeSimple($event, 'lenghtService')" :picker-options="{
            start: '00:30',
            step: '00:30',
            end: '3:30'
          }" :clearable="false" placeholder="Select time">
          </el-time-select>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="event.nbServices < 2">
        <el-form-item label="Première heure pour la prise de réservation">
          <el-time-select :value="event.hMinTakeResa" @input="changeThenCallPopulateCT($event, 'hMinTakeResa')"
            :picker-options="{
              start: event.opening,
              step: '00:15',
              end: event.closing
            }" :clearable="false" placeholder="Select time">
          </el-time-select>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="event.nbServices < 2">
        <el-form-item label="Dernière heure pour la prise de réservation">
          <el-time-select :value="event.hMaxTakeResa" @input="changeThenCallPopulateCT($event, 'hMaxTakeResa')"
            :picker-options="{
              start: event.opening,
              step: '00:15',
              end: event.closing
            }" :clearable="false" placeholder="Select time">
          </el-time-select>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="event.nbServices < 2">
        <el-form-item label="Intervalle de réservation">
          <el-time-select :value="event.intervalResa" @input="changeThenCallPopulateCT($event, 'intervalResa')"
            :picker-options="{
              start: '00:05',
              step: '00:05',
              end: '3:00'
            }" :clearable="false" placeholder="Select time">
          </el-time-select>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="event.nbServices < 2">
        <el-form-item label="Limite entre réservations">
          <el-time-select :value="event.limitSecuChrono" @input="changeSimple($event, 'limitSecuChrono')"
            :picker-options="{
              start: '00:15',
              step: '00:15',
              end: '2:00'
            }" :clearable="false" placeholder="Select time">
          </el-time-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="Nombre min de personnes par résa">
          <el-input-number :value="event.nbMinByResa" @input="changeSimple($event, 'nbMinByResa')" :min="1"
            :max="100"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="Nombre max de personnes par résa">
          <el-input-number :value="event.nbMaxByResa" @input="changeSimple($event, 'nbMaxByResa')" :min="1"
            :max="100"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="Limite avant annulation">
          <el-time-select :value="event.limitAnnulation" @input="changeSimple($event, 'limitAnnulation')"
            :picker-options="{
              start: '00:00',
              step: '01:00',
              end: '72:00'
            }" :clearable="false" placeholder="Select time">
          </el-time-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="Nombre max de résa pour le service">
          <el-input-number :value="event.nbMaxResa" @input="changeSimple($event, 'nbMaxResa')" :min="0"
            :max="9999"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12" style="min-height:70px">
        <el-form-item label="Service visible à la réservation en ligne" style="text-align:center">
          <el-switch v-model="visible" active-color="#00cec0" inactive-color="#e95d5d">
          </el-switch>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="Fermeture automatique" style="text-align:center">
          <el-switch v-model="event.closeAuto" active-color="#00cec0" inactive-color="#e95d5d">
          </el-switch>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="event.closeAuto">
        <el-form-item label="Delai avant fermeture automatique">
          <el-time-select :value="event.closeAutoTime" @input="changeSimple($event, 'closeAutoTime')" :picker-options="{
            start: '00:00',
            step: '00:30',
            end: '72:00'
          }" :clearable="false" placeholder="Select time">
          </el-time-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="Caution ou prépaiement" style="text-align:center">
          <el-switch v-model="event.cashOn" active-color="#00cec0" inactive-color="#e95d5d">
          </el-switch>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="event.cashOn">
        <el-form-item label="Type" style="text-align:center">
          <el-select v-model="event.cashType" placeholder="Type">
            <el-option label="Caution" value="caution"></el-option>
            <el-option label="Prépaiement" value="prepaiement"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="event.cashOn">
        <el-form-item label="Prix / couverts" style="text-align:center">
          <el-input class="inputEuro" placeholder="Prix / couverts" v-model="event.cashPrice"
            @change="replaceV()"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="event.cashOn">
        <el-form-item label="Couverts min." style="text-align:center">
          <el-input class="inputCouv" placeholder="couverts min." v-model="event.cashCouv"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <el-row v-loading="loading">
    <el-col :span="7" :offset="9">
      <el-button class="dark" type="primary" @click="closeDialog()">Annuler</el-button>
    </el-col>
    <el-col :span="7" :offset="1">
      <el-button type="primary" @click="validModifications()">Valider</el-button>
    </el-col>
  </el-row>
  <el-dialog title="Chevauchement détecté" :visible.sync="showOverlapDialog" width="30%"
    :before-close="handleDialogClose">
    <el-row>
      <el-col :span="24" style="margin-bottom: 20px;">
        L'événement que vous créez est programmé en même temps que des services existants. Voulez-vous fermer les
        services concernés ?
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="7" :offset="9">
        <el-button class="dark" type="primary" @click="cancelOverlap">Non</el-button>
      </el-col>
      <el-col :span="7" :offset="1">
        <el-button type="primary" @click="confirmOverlap">Oui</el-button>
      </el-col>
    </el-row>
  </el-dialog>
</div>
